import { render, staticRenderFns } from "./SfModal.vue?vue&type=template&id=13e7f95a"
import script from "./SfModal.vue?vue&type=script&lang=js"
export * from "./SfModal.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfModal.vue?vue&type=style&index=0&id=13e7f95a&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "367825e8"
  
)

export default component.exports